import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoriesWithProduct } from 'app/_models/categories'
import { ProductOptions } from "app/_models/optionsList/options"
import { OptionslistService } from 'app/_services/optionslist.service';
import { CrudCategoryService } from 'app/_services/MasterCrudOps/crudcategory.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
declare const swal: any;

@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.css']
})
export class EditCategoryComponent  implements OnInit {
  editCategoryForm: FormGroup;
  editCategory: CategoriesWithProduct;
  productOptions: ProductOptions[] = [];
  pageNumber: number;
  pageSize: number;


  constructor( 
    private readonly fb: FormBuilder,
    private  readonly toastr: ToastrService,
    private  readonly  dialogRef: MatDialogRef<EditCategoryComponent>,
    private  readonly crudCategoryService: CrudCategoryService,
    private  readonly optionslistService: OptionslistService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.editCategory = JSON.parse(JSON.stringify(data.category));
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.optionslistService.getProductsOptions().subscribe(productOptions => {
      this.productOptions = productOptions;
    })
  }

  ngOnInit(): void {
    this.editCategoryForm = this.fb.group({
      productId:[this.editCategory.productId, [Validators.required]],
      categoryName: [this.editCategory.categoryName ?? "", [Validators.required, Validators.maxLength(50)],
      ],
      description: [this.editCategory.description ?? "", [Validators.required, Validators.maxLength(100)],
      ],
    });
  }
 
  close() {
    this.dialogRef.close();
  }

 

  saveCategory() {
    const productId = this.editCategoryForm.value.productId;
    const categoryName = (this.editCategoryForm.value.categoryName ?? "").trim();
    const description =  (this.editCategoryForm.value.description ?? "").trim();
    let errorMessage = "";
    if (!categoryName) {
      errorMessage += "Catergory Name is required.\n";
    }
    if (categoryName.length > 50) {
      errorMessage += "category Name cannot be more than 50 characters.\n";
    }
    if (!productId || productId == 0) {
      errorMessage += "Product is required.\n";
    }
    if (!description) {
      errorMessage += "Description is required.\n";
    }
    if (description.length > 100) {
      errorMessage += "Description Name cannot be more than 100 characters.\n";
    }

    if (errorMessage) {
      swal({
        title: "",
        text: errorMessage,
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
      return;
    }

    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES, Update IT!'
    }).then((result) => {
      if (result === true) {
        let model = {categoryId:this.editCategory.categoryId, productId:productId, categoryName:categoryName, description:description};
        this.updateCategory(model)
      }
      else {
        this.toastr.info('result not saved')
      }
    })
  }

  updateCategory(model:any) {
    this.crudCategoryService.updateCategory(model).subscribe
    (
      data => {     
                if (data.didError) {
                  swal({
                    title: '',
                    text: data.message,
                    type: 'error',
                    confirmButtonClass: 'btn btn-info'
                  });
                }
                else {
                  this.dialogRef.close(true);
                  swal({
                    title: '',
                    text: data.message,
                    type: 'success',
                    confirmButtonClass: 'btn btn-info'
                  });
                  let result = {
                    status: true,
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize
                  };
                  this.dialogRef.close(result);
                }
              },
     (error) => 
            {
              let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }
              swal({
                title: '',
                text: errorMessage,
                type: 'error',
                confirmButtonClass: 'btn btn-info'
              });
            }
    )
     
  }

}


